<template>
  <div>
    <CRow>
      <CCol col="12">
        <CCard>
          <CCardHeader>
            <strong>
              گزارش سورس ورودی
              {{ source_data.name }}
            </strong>

          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="6 col-sm-3">
                <date-picker v-model="start_date" label="از تاریخ"/>
              </CCol>
              <CCol col="6 col-sm-3">
                <date-picker v-model="end_date" label="تا تاریخ"/>
              </CCol>
              <CCol col="1 col-sm-1">
                <CButton color="primary" @click="get_list()">
                  <CIcon size="sm" name="cil-zoom"/>
                </CButton>
              </CCol>
            </CRow>
            <div>سفارشات فروش</div>
            <CDataTableFixed
                :items="order_reports"
                :fields="fields_orders"

                :items-per-page="20"
                hover
                sorter
                pagination
            >
              <template #row="{item,index}">
                <td>
                  <p class="text-muted">{{ index + 1 }}</p>
                </td>
              </template>

              <template #user="{item}">
                <td>
                  <p class="text-muted">{{ item.user.name }}</p>
                </td>
              </template>
              <template #total_price="{item}">
                <td>
                  <p class="text-muted">{{ get_currency(item.total_price) }}</p>
                </td>
              </template>
              <template #status="{item}">
                <td>
                  <p class="text-muted" v-if="items_status.length>0">{{ items_status.filter(x=>x.id==item.statuses[item.statuses.length-1].id)[0].title.title }}</p>
                </td>
              </template>
              <template #operation="{item,index}">
                <td class="py-2">
                  <CButton
                      color="primary"
                      variant="outline"
                      square
                      size="sm"
                      @click="$router.push({path: '/dashboard/orders/info/' + item.id})"
                  >
                    <CIcon name="eye" size="sm"/>
                  </CButton>

                </td>
              </template>


            </CDataTableFixed>
            <div>بازدید کالا</div>
            <CDataTableFixed
                :items="product_report"
                :fields="fields_products"

                :items-per-page="20"
                hover
                sorter
                pagination
            >
              <template #row="{item,index}">
                <td>
                  <p class="text-muted">{{ index + 1 }}</p>
                </td>
              </template>



            </CDataTableFixed>
          </CCardBody>

        </CCard>
      </CCol>
    </CRow>


  </div>

</template>

<script>
import axios from "axios";

import {bus} from '../../main';


export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name: new Date().getTime() + "_" + this.$vnode.tag,
      source_data: {name: ''},
      start_date: '',
      end_date: '',
      order_reports: [],
      product_report: [],
      fields_orders:[
        {key: 'row', label: '#', _style: 'width:7%'},
        {key: 'user', label: 'مشتری', _style: 'width:20%'},
        {key: 'total_price', label: 'مبلغ', _style: 'width:20%'},
        {key: 'status', label: 'وضعیت', _style: 'width:20%'},
        {key: 'operation', label: 'عملیات', _style: 'width:20%'},

      ],
      fields_products: [
        {key: 'row', label: '#', _style: 'width:7%'},
        {key: 'title', label: 'عنوان', _style: 'width:20%'},
        {key: 'count', label: 'تعداد بازدید', _style: 'width:20%'},
        // {key: 'income_value', label: 'مقدار کلید', _style: 'width:20%'},

      ],
      items_status: [],

      status_form: 0,

    }
  },
  mounted() {
    this.start_date = this.get_day_before_today_in_day(7)
    this.end_date = this.get_today()
    this.get_statuses();

    this.get_list();

  },
  watch: {},
  methods: {
    get_statuses() {
      var self = this;
      axios.post('/api/admin/order/get_order_status', {}).then(function (response) {
        self.items_status = response.data.orders
        self.get_news();
      }).catch(function (error) {
        console.log(error);
      });

    },

    get_list() {
      var self = this;
      var formData = new FormData();
      formData.append('start_date', this.start_date)
      formData.append('end_date', this.end_date)
      formData.append('id', this.$route.params.id)
      axios.post('/api/admin/site/income_source_reports', formData, {}).then(function (response) {

        var content_cats = response.data;


        self.order_reports = content_cats.orders
        self.product_report = content_cats.product_views
        self.source_data = content_cats.source

      })
          .catch(function (error) {

            console.log(error);
          });

    },

  }
}


</script>
